"use client";

import { useState, useEffect, useCallback, CSSProperties } from "react";
import { createPortal } from "react-dom";

interface DeprecationNoticeProps {
  product: string;
  mode?: "deprecated" | "active";
  vaultUrl?: string;
  telegramUrl?: string;
  xUrl?: string;
}

const GRADIENT = "linear-gradient(135deg, #47C499, #215BC4)";

function AnteLogo({ size = 48 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M42.7548 13.1719V34.8281L23.9999 45.6563L5.24507 34.8281V13.1719L23.9999 2.34375L42.7548 13.1719ZM7.30757 14.3627V33.6373L23.9999 43.2746L40.6923 33.6373V14.3627L23.9999 4.72531L7.30757 14.3627Z"
        fill="url(#ante-dn-grad)"
      />
      <path
        d="M23.9999 0L28.0594 2.34375V7.03125L23.9999 9.375L19.9404 7.03125V2.34375L23.9999 0Z"
        fill="url(#ante-dn-grad)"
      />
      <path
        d="M23.9999 38.625L28.0594 40.9688V45.6563L23.9999 48L19.9404 45.6563V40.9688L23.9999 38.625Z"
        fill="url(#ante-dn-grad)"
      />
      <path
        d="M40.7343 28.9688L44.7938 31.3125V36L40.7343 38.3438L36.6748 36V31.3125L40.7343 28.9688Z"
        fill="url(#ante-dn-grad)"
      />
      <path
        d="M7.26555 28.9688L11.325 31.3125V36L7.26555 38.3438L3.20605 36V31.3125L7.26555 28.9688Z"
        fill="url(#ante-dn-grad)"
      />
      <path
        d="M40.7343 9.65625L44.7938 12V16.6875L40.7343 19.0313L36.6748 16.6875V12L40.7343 9.65625Z"
        fill="url(#ante-dn-grad)"
      />
      <path
        d="M7.26555 9.65625L11.325 12V16.6875L7.26555 19.0313L3.20605 16.6875V12L7.26555 9.65625Z"
        fill="url(#ante-dn-grad)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4215 33.0483C16.3922 33.1564 16.4287 33.272 16.5162 33.3422C17.4696 34.1076 18.5349 34.7243 19.6727 35.1695C19.777 35.2103 19.8951 35.1842 19.9738 35.1047L22.0134 33.0471C22.0816 32.9782 22.18 32.9493 22.2751 32.9678C23.3912 33.1864 24.5625 33.1982 25.7353 32.9721C25.8295 32.954 25.927 32.9825 25.9952 33.0504L28.0699 35.1095C28.1488 35.1879 28.2659 35.2135 28.3694 35.1733C29.5248 34.7242 30.5771 34.1087 31.5056 33.362C31.5925 33.2922 31.6287 33.1774 31.5997 33.0696L30.8429 30.2523C30.8178 30.1592 30.8416 30.0601 30.9045 29.9874C31.6604 29.111 32.2445 28.0964 32.6235 27.0017C32.655 26.9108 32.7286 26.8406 32.8214 26.8158L35.6333 26.0644C35.741 26.0356 35.8221 25.9467 35.8389 25.8365C36.0195 24.6567 36.025 23.4353 35.8353 22.2075C35.8183 22.0975 35.7375 22.0085 35.6304 21.9792L32.8145 21.2074C32.7218 21.182 32.6483 21.1116 32.617 21.0208C32.2259 19.8894 31.6301 18.8783 30.8832 18.0184C30.8196 17.9451 30.7955 17.8452 30.8208 17.7515L31.5783 14.9516C31.6077 14.8435 31.5711 14.7279 31.4836 14.6577C30.5302 13.8924 29.4649 13.2757 28.3271 12.8305C28.2228 12.7897 28.1047 12.8158 28.026 12.8953L25.9864 14.953C25.9182 15.0218 25.8198 15.0508 25.7247 15.0321C24.6086 14.8136 23.4374 14.8018 22.2645 15.0279C22.1704 15.0461 22.0728 15.0175 22.0047 14.9498L19.9299 12.8906C19.851 12.8122 19.7337 12.7865 19.6303 12.8267C18.475 13.2758 17.4228 13.8914 16.4941 14.6381C16.4073 14.7078 16.3712 14.8227 16.4001 14.9305L17.157 17.7478C17.182 17.8408 17.1582 17.9399 17.0954 18.0127C16.3394 18.8891 15.7552 19.9036 15.3763 20.9983C15.3448 21.0892 15.2711 21.1594 15.1783 21.1842L12.3665 21.9356C12.2589 21.9644 12.1777 22.0533 12.1608 22.1635C11.9874 23.2972 11.9754 24.4695 12.1431 25.6488C12.1589 25.7599 12.2398 25.8503 12.3478 25.8802L15.1399 26.6553C15.2336 26.6813 15.3075 26.7534 15.3379 26.8459C15.7276 28.0313 16.3404 29.088 17.1166 29.9817C17.1802 30.0549 17.2043 30.1549 17.179 30.2484L16.4215 33.0483ZM23.9999 30.25C27.4517 30.25 30.2499 27.4518 30.2499 24C30.2499 20.5482 27.4517 17.75 23.9999 17.75C20.5481 17.75 17.7499 20.5482 17.7499 24C17.7499 27.4518 20.5481 30.25 23.9999 30.25Z"
        fill="url(#ante-dn-grad)"
      />
      <defs>
        <linearGradient
          id="ante-dn-grad"
          x1="0"
          y1="0"
          x2="53.7928"
          y2="40.2599"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#47C499" />
          <stop offset="1" stopColor="#215BC4" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function getLsKey(product: string) {
  return (
    "ante-deprecation-dismissed-" + product.replace(/\s+/g, "-").toLowerCase()
  );
}

const styles: Record<string, CSSProperties> = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0, 0, 0, 0.5)",
    backdropFilter: "blur(8px)",
    WebkitBackdropFilter: "blur(8px)",
    zIndex: 999999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 16,
    fontFamily: "system-ui, -apple-system, 'Segoe UI', sans-serif",
    overflowY: "auto",
  },

  modal: {
    background: "#FFFFFF",
    border: "1px solid #E5E7EB",
    borderRadius: 8,
    maxWidth: 440,
    width: "100%",
    padding: "28px 24px",
    boxShadow: "0 24px 48px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.04)",
    margin: "auto",
  },

  modalLogo: {
    display: "flex",
    justifyContent: "center",
    marginBottom: 20,
  },

  modalTitle: {
    fontSize: 18,
    fontWeight: 600,
    color: "#111827",
    margin: "0 0 12px",
    lineHeight: 1.3,
    textAlign: "center",
  },

  modalBody: {
    fontSize: 14,
    color: "#6B7280",
    lineHeight: 1.6,
    margin: "0 0 16px",
    textAlign: "center",
  },

  links: {
    marginBottom: 20,
    display: "flex",
    flexWrap: "wrap",
    gap: 16,
    justifyContent: "center",
  },

  link: {
    color: "#2563EB",
    textDecoration: "none",
    fontWeight: 500,
    fontSize: 14,
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
  },

  buttons: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
  },

  btnPrimary: {
    fontFamily: "inherit",
    fontSize: 14,
    fontWeight: 600,
    padding: "14px 20px",
    borderRadius: 8,
    cursor: "pointer",
    border: "none",
    textAlign: "center",
    textDecoration: "none",
    display: "block",
    minHeight: 44,
    boxSizing: "border-box",
    background: GRADIENT,
    color: "#FFFFFF",
    transition: "opacity 0.2s, box-shadow 0.2s",
  },

  btnSecondary: {
    fontFamily: "inherit",
    fontSize: 14,
    fontWeight: 500,
    padding: "14px 20px",
    borderRadius: 8,
    cursor: "pointer",
    border: "1px solid #D1D5DB",
    textAlign: "center",
    textDecoration: "none",
    display: "block",
    minHeight: 44,
    boxSizing: "border-box",
    background: "transparent",
    color: "#6B7280",
    transition: "background 0.2s, color 0.2s",
  },

  banner: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 999998,
    background: "#F9FAFB",
    borderBottom: "1px solid #E5E7EB",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.06)",
    padding: "14px 20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "system-ui, -apple-system, 'Segoe UI', sans-serif",
    fontSize: 14,
    color: "#374151",
    cursor: "pointer",
    minHeight: 56,
  },

  bannerAccent: {
    position: "absolute",
    left: 0,
    top: 0,
    bottom: 0,
    width: 4,
    background: GRADIENT,
  },

  bannerInner: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 12,
    flexWrap: "wrap",
  },

  bannerText: {
    fontWeight: 500,
    textAlign: "center",
  },

  bannerSpacer: {
    minHeight: 56,
  },
};

const mediaQuery = `
  @media (min-width: 480px) {
    [data-ante-dn-modal] { padding: 36px 32px; }
    [data-ante-dn-title] { font-size: 20px; margin-bottom: 16px; }
    [data-ante-dn-body] { font-size: 15px; margin-bottom: 20px; }
    [data-ante-dn-banner] { padding: 16px 24px; min-height: 64px; }
    [data-ante-dn-banner-accent] { width: 5px; }
    [data-ante-dn-spacer] { min-height: 64px; }
  }
`;

function Modal({
  product,
  mode,
  vaultUrl,
  telegramUrl,
  xUrl,
  onDismiss,
}: {
  product: string;
  mode: "deprecated" | "active";
  vaultUrl: string;
  telegramUrl: string;
  xUrl: string;
  onDismiss: () => void;
}) {
  const isDeprecated = mode === "deprecated";

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === "Escape") onDismiss();
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onDismiss]);

  return createPortal(
    <div
      style={styles.overlay}
      onClick={(e) => {
        if (e.target === e.currentTarget) onDismiss();
      }}
      role="presentation"
    >
      <div
        data-ante-dn-modal
        style={styles.modal}
        role="dialog"
        aria-modal="true"
        aria-labelledby="ante-dn-title"
        aria-describedby="ante-dn-desc"
      >
        <div style={styles.modalLogo}>
          <AnteLogo size={48} />
        </div>
        <h2 data-ante-dn-title id="ante-dn-title" style={styles.modalTitle}>
          {isDeprecated ? product : "NEW: Ante Vaults"}
        </h2>
        {isDeprecated ? (
          <>
            <p data-ante-dn-body id="ante-dn-desc" style={styles.modalBody}>
              This product is being phased out. If you need assistance with your
              account, please reach out to our team.
            </p>
            <div style={styles.links}>
              <a
                href={telegramUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={styles.link}
              >
                Telegram
              </a>
              <a
                href={xUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={styles.link}
              >
                X (@AnteVaults)
              </a>
            </div>
            <p style={styles.modalBody}>
              Some features of {product} might be integrated into our new
              product, Ante Vaults.
            </p>
          </>
        ) : (
          <p data-ante-dn-body id="ante-dn-desc" style={styles.modalBody}>
            {`You can continue using ${product} as usual. We\u2019ve also launched Ante Vaults, a new platform for digital asset continuity and protection. In the future, ${product} features may also become available in Ante Vaults.`}
          </p>
        )}
        <div style={styles.buttons}>
          <a
            href={vaultUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={styles.btnPrimary}
          >
            Explore Ante Vaults
          </a>
          <button type="button" style={styles.btnSecondary} onClick={onDismiss}>
            {isDeprecated ? "Close" : `Continue to ${product}`}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}

export function DeprecationNotice({
  product,
  mode = "deprecated",
  vaultUrl = "https://ante.org",
  telegramUrl = "https://t.me/+HTTickJr2cg0MDUx",
  xUrl = "https://x.com/AnteVaults",
}: DeprecationNoticeProps) {
  const [mounted, setMounted] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const isDeprecated = mode === "deprecated";

  useEffect(() => {
    const dismissed =
      typeof window !== "undefined" &&
      localStorage.getItem(getLsKey(product)) === "true";
    setModalOpen(!dismissed);
    setMounted(true);
  }, [product]);

  const dismiss = useCallback(() => {
    setModalOpen(false);
    try {
      localStorage.setItem(getLsKey(product), "true");
    } catch {}
  }, [product]);

  const openModal = useCallback(() => {
    setModalOpen(true);
  }, []);

  if (!mounted) return null;

  const bannerLabel = isDeprecated
    ? `${product} is being phased out. Learn more`
    : "NEW: Ante Vaults is here. Learn more";

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: mediaQuery }} />

      {!modalOpen && (
        <>
          <div data-ante-dn-spacer style={styles.bannerSpacer} />
          <div
            data-ante-dn-banner
            style={styles.banner}
            role="button"
            tabIndex={0}
            onClick={openModal}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                openModal();
              }
            }}
            aria-label={`${bannerLabel} Click to learn more.`}
          >
            <div data-ante-dn-banner-accent style={styles.bannerAccent} />
            <div style={styles.bannerInner}>
              <AnteLogo size={24} />
              <span style={styles.bannerText}>{bannerLabel}</span>
            </div>
          </div>
        </>
      )}

      {modalOpen && (
        <Modal
          product={product}
          mode={mode}
          vaultUrl={vaultUrl}
          telegramUrl={telegramUrl}
          xUrl={xUrl}
          onDismiss={dismiss}
        />
      )}
    </>
  );
}
